import { IApplicationState } from '../../../../../../../types/types';
import { TSearchQuery } from '../types';

export const getSearchQuery = (
    state: IApplicationState
): TSearchQuery => {
    return state.openBoardsDialog && state.openBoardsDialog.header && state.openBoardsDialog.header.searchQuery
}
